import { InputNumber } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../MdmCardFormStore";
import { FnFocus, FormField } from "../types/MdmCardFormTypes";
import { ZCompInputNumber } from "../types/metaComponent";
import { FieldBox } from "./FieldBox";
import { focusCtrl } from "./focusCtrl";

interface PropsCardInputNumber {
  form: MdmCardFormStore;
  field: FormField;
  component: ZCompInputNumber;
  focusBk: (onFocus: FnFocus) => void;
}

export const CardInputNumber: React.FC<PropsCardInputNumber> = observer(
  (props) => {
    const { field, form, component, focusBk } = props;
    const { data, path } = field;
    const n: number | null = data?.type === "number" ? data.value : null;
    const addonAfter =
      component.addonAfter && form.evaluateText(component.addonAfter);
    const error = form.errors[field.path];

    const iref = React.useRef<HTMLInputElement>(null);
    React.useEffect(focusCtrl(iref.current, focusBk), [iref.current]);

    return (
      <FieldBox field={field} form={form}>
        <InputNumber
          ref={iref}
          style={{ width: "100%" }}
          status={error ? "error" : undefined}
          min={component.min ?? undefined}
          max={component.max ?? undefined}
          value={n}
          disabled={form.isItemDisabled(field)}
          addonAfter={addonAfter}
          precision={component.precision ?? undefined}
          onChange={(value) => {
            field.setData({ type: "number", value, name: field.meta.name });
            form.onChange(path);
          }}
        />
      </FieldBox>
    );
  },
);
